import React, { createContext, useContext, useState, useCallback } from 'react';
import translations from './translations';

const LangContext = createContext();

export function LangProvider({ children, storageKey = 'lang' }) {
  const [lang, setLangState] = useState(() => localStorage.getItem(storageKey) || 'de');
  const [showPicker, setShowPicker] = useState(false);

  const setLang = useCallback((l) => {
    localStorage.setItem(storageKey, l);
    setLangState(l);
    setShowPicker(false);
  }, [storageKey]);

  const toggleLang = useCallback(() => {
    setLang(lang === 'de' ? 'en' : 'de');
  }, [lang, setLang]);

  const t = useCallback((key, vars) => {
    const activeLang = lang || 'en';
    let str = translations[activeLang]?.[key] || translations.en[key] || key;
    if (vars) {
      Object.entries(vars).forEach(([k, v]) => {
        str = str.replace(new RegExp(`\\{${k}\\}`, 'g'), v);
      });
    }
    return str;
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang: lang || 'en', setLang, toggleLang, t, showPicker, setShowPicker }}>
      {children}
    </LangContext.Provider>
  );
}

export function useT() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error('useT must be used within LangProvider');
  return ctx;
}

export default LangContext;
